
import { getQceitQuery } from '../../store/modules/ide';
const Base64 = require('js-base64').Base64

const socketData = {
  socket: null,
  context: null,
}

const emit = (cmd, data) => {
  if (socketData.socket) {
    socketData.socket.emit(cmd, data)
  } else {
    console.error('socket = null,', cmd, data);
    socketData.context.$message.error(`socket = null,${cmd}`);
  }
}

export default {
  setSocket: (context, socket) => {
    console.log('--setSocket:', socket);
    socket && (socketData.socket = socket);
    socketData.context = context;
  },

  emit,

  runCode: (code, query, language, isEdit) => {
    const data = getQceitQuery(query, {
      code: Base64.encode(code),
      language: language,
      cbip: true,
      isEdit,
    });
    console.log('---run:', data, language);
    emit('run', data);
  },

  testCode: (code, query, language, isEdit) => {
    const data = getQceitQuery(query, {
      code: Base64.encode(code),
      language: language,
      cbip: true,
      isEdit,
    });
    console.log('---test:', data, language);
    emit('test', data);
  },

  stopCode: ({addr, runToken, sessionId}, query) => {
    const data = getQceitQuery(query, {
      addr, runToken, sessionId
    });
    emit('stop', data);
  },

  input: ({addr, runToken, sessionId}, input, query) => {
    const data = getQceitQuery(query, {
      addr, runToken, sessionId, input
    });
    console.log('--input: addr:', data.addr)
    emit('input', data);
  },

  getTest: (SolutionID, query) => {
    const data = getQceitQuery(query, {
      SolutionID
    });
    emit('getTest', data);
  },
};
